<template>
  <span v-if="priceListItem.hidden" style="font-size: 1em">
    <b-badge
      v-b-tooltip.hover
      class="text-white cursor-help"
      variant="secondary"
      style="padding: 0.5em"
    >
      <Tooltip :value="tooltipDescription" icon-class="fa fa-eye-slash" />
    </b-badge>
  </span>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "HiddenPriceListItemBadge",

  components: {
    Tooltip,
  },

  props: {
    priceListItem: {
      type: Object,
      required: true,
    },
  },

  computed: {
    tooltipDescription() {
      const description = [];

      if (this.priceListItem.hiddenFor) {
        description.push(this.$t(`Hidden for ${this.priceListItem.hiddenFor}`));
      }

      if (this.priceListItem.hiddenWeekdays && this.priceListItem.hiddenWeekdays.length > 0) {
        const translatedDays = this.priceListItem.hiddenWeekdays.map((day) => this.$t(day));

        translatedDays.sort((a, b) => {
          const daysOrder = [
            "poniedziałek",
            "wtorek",
            "środa",
            "czwartek",
            "piątek",
            "sobota",
            "niedziela",
          ];
          return daysOrder.indexOf(a) - daysOrder.indexOf(b);
        });

        description.push(
          this.$t("Hidden on days: {daysOfWeek}", {
            daysOfWeek: translatedDays.join(", "),
          }),
        );
      }

      return description.join(". ");
    },
  },
};
</script>
